/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';
import {
    Input,
    Label,
    Row,
    Card,
    CardBody
} from 'reactstrap';
import { IPopUp } from '../../../components/Common/iComponents/iPopUp/IpopUp';
import IForm from './testIForm';

const FormBrandModalColors = ({ selectedRow, onChangeColor }: any) => {
    const tableConfig = [
        {
            "text": "Number",
            "dataField": "Number",
            "visibleInModalHeader": true,
            "isMilestone": true,
            "visibleInModalBody": true,
            "visibleInModalTotal": true,

        },
        {
            "text": "Status",
            "dataField": "Status",
            "visibleInModalHeader": true,
            "isMilestone": true,
            "visibleInModalBody": true,
            "visibleInModalTotal": true,
        },
        {
            "text": "TotalPieces",
            "dataField": "TotalPieces",
            "visibleInModalHeader": true,
            "isMilestone": false,
            "visibleInModalBody": true,
            "visibleInModalTotal": true,
        },
        {
            "text": "ShippingDate",
            "dataField": "ShippingDate",
            "visibleInModalHeader": true,
            "isMilestone": true,
            "visibleInModalBody": false,
            "visibleInModalTotal": false,
        },
        {
            "text": "CreatedOn",
            "dataField": "CreatedOn",
            "visibleInModalHeader": true,
            "isMilestone": false,
            "visibleInModalBody": true,
            "visibleInModalTotal": false,
        }
    ]

    const selectedRowTest = {
        "id": 3568,
        "Number": "3879831",
        "CreatedOn": moment().format("YYYY-MM-DD"),
        "Status": "Delivered",
        "ShippingDate": moment().add(1, "M").add(15, "d").format("YYYY-MM-DD"),
        "TotalPieces": 5,
    }

    const [state, setState] = useState<any>(
        {
            modalHeaderBackground: "#ffffff",
            modalHeaderTitle: "#b3bac1",
            modalHeaderText: "#495057",

            isMilestoneBackground: "#ffffff",
            isMilestoneCircle: "#ffaf27",
            isMilestoneText: "#495057",

            modalBodyBackground: "#d8dde2",
            modalBodyTitle: "#aeb6be",
            modalBodyText: "#495057",

            modalTotalBackground: "#101340",
            modalTotalText: "#f2f1f2"
        }
    );

    useEffect(() => {
        const newObject = { ...state }
        Object.keys(state).map((item: any) => {
            newObject[item] = !selectedRow?.[item] || selectedRow?.[item] === "null" ? state[item] : selectedRow?.[item]
        })
        setState(newObject)
    }, [selectedRow])
    const isDarkColor = (color: any) => {
        if (!color) color = '#000000';
        const r = parseInt(color?.substring(1, 3), 16);
        const g = parseInt(color?.substring(3, 5), 16);
        const b = parseInt(color?.substring(5, 7), 16);
        let luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        if (isNaN(luminance)) luminance = 0;
        return luminance < 0.5;
    };
    return (
        <Card className='mt-5'>
            <CardBody>
                <Row >
                    <h5 className='text-center colorTextConfigBrand'>
                        Modal Colors
                    </h5>
                    <div className='col-7 row' style={{ height: 470, paddingTop: 65 }} >
                        {Object.keys(state)?.map((item: any) => {
                            const fontDarker = isDarkColor(state[item]);
                            return (
                                <div key={item} className="col-sm-4 row text-center container-colors">
                                    <div className="btn-group secondary">
                                        <Label className="inputTextConfigBrandModal">
                                            <div
                                                className="ps-1 position-absolute labelConfigBrand cursor-pointer text-capitalize"
                                                style={{ color: fontDarker ? 'white' : 'black' }}
                                            >
                                                {item.replace(/([A-Z])/g, ' $1').trim()}
                                            </div>
                                            <Input
                                                type="color"
                                                className="cursor-pointer inputConfigBrand"
                                                placeholder={item}
                                                plaintext={true}
                                                defaultValue={state[item]}
                                                value={state[item]}
                                                onChange={(e: any) => {
                                                    const n = item;
                                                    setState({
                                                        ...state,
                                                        [n]: e.target.value,
                                                    });
                                                    onChangeColor(e, n)
                                                }}
                                            />
                                        </Label>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className='col-5' style={{ backgroundColor: "white", borderRadius: 50 }}>
                        <IPopUp
                            stateTest={true}
                            switchStateAdd={true}
                            modalTitleAdd={'Modal Colors'}
                            modaleTitleUpdate={'Modal Colors'}
                            colorHeaderPop={'#101340'}
                        >
                            <IForm selectedRow={selectedRowTest} milestoneConfig={tableConfig} columsPop={5} colors={state} />
                        </IPopUp>

                    </div>
                </Row>
            </CardBody>
        </Card>
    )

}

FormBrandModalColors.propTypes = {
    selectedRow: PropTypes.object,
    onChangeColor: PropTypes.any
};

export default FormBrandModalColors;